import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {Menu} from "../models/menu";
import {CategoryService} from "../services/category.service";
import {PromotionSubscriptionService} from "@core/shared/services/promotion-subscription.service";

@Injectable({
    providedIn: 'root'
})
export class PromotionSubscriptionItemResolver  {

    constructor(
        private promotionSubscriptionService: PromotionSubscriptionService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return this.promotionSubscriptionService.getItemAPI(parseInt(route.paramMap.get('id')));
    }
}
